import { createSlice } from "@reduxjs/toolkit";
import { dictService } from "../../services/dictService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";

export const getStudents = createCustomAsyncThunk(
    "dicts/students/get",
    async params => await dictService.getStudents(params)
)

const studentsSlice = createSlice({
    name: "dicts/students",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getStudents.pending, state => { state.isLoading = true })
            .addCase(getStudents.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getStudents.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const studentSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.students)

export default studentsSlice.reducer